export default {
  'main-menu.cases.title': 'Cases',
  'main-menu.cases-create.title': 'New order',
  'main-menu.cases-creation-orders.title': 'Diagnostics orders',
  'main-menu.logout.title': 'Logout',
  'main-menu.code-scanner-status.tooltip': 'To speed up work, you can read material codes with a scanner.',

  'common.phrases.yes': 'Yes',
  'common.phrases.no': 'No',
  'common.autocomplete.noDataText': 'No data available',
  'common.bytes': 'Bytes',
  'common.byte': 'Byte',
  'common.kb': 'KB',
  'common.mb': 'MB',
  'common.gb': 'GB',
  'common.tb': 'TB',

  'cases.materials.tissue': 'Raw material in formalin',
  'cases.materials.tissues': 'Raw materials in formalin',
  'cases.materials.block': 'Histological block',
  'cases.materials.blocks': 'Histological blocks',
  'cases.materials.slide': 'Histological preparation',
  'cases.materials.slides': 'Histological preparations',
  'cases.materials.document': 'Paper document',
  'cases.materials.documents': 'Paper documents',
  'cases.materials.file': 'Electronic media',
  'cases.materials.files': 'Electronic media',

  'cases.filters.title': 'Filters',
  'cases.filters.statuses.label': 'Select statuses',
  'cases.filters.services.label': 'Select services',
  'cases.filters.services.no-data.label': 'No services',
  'cases.filters.specialists.label': 'Select specialist',
  'cases.filters.specialists.no-data.label': 'No specialists',
  'cases.filters.creationDatetime.label': 'Creation datetime range',
  'cases.filters.creationDatetime.start.label': 'Start Date ',
  'cases.filters.creationDatetime.end.label': 'End Date ',
  'cases.filters.fulltextSearch.label': 'Search by title / patient name / ext. label',

  'cases.table.columns.header.title': 'Title',
  'cases.table.columns.header.creationDatetime': 'Created date',
  'cases.table.columns.header.receiptMaterialsDatetime': 'Materials receiving date',
  'cases.table.columns.header.reportValidatedAt': 'Report validated at',
  'cases.table.columns.header.status': 'Status',
  'cases.table.columns.header.services': 'Services',
  'cases.table.columns.header.report': 'Report',
  'cases.table.columns.header.patientName': 'Patient name',
  'cases.table.columns.header.externalLabel': 'External label',
  'cases.table.columns.header.clientSpecialist': 'Client specialist',
  'cases.table.columns.header.price': 'Price',
  'cases.table.noResultText': 'No available cases',
  'cases.table.itemsPerPage': 'Cases per page',
  'cases.showReport': 'Show report',
  'caseDetails.case.title': 'Case',
  'caseDetails.caseInDp.label': 'Case in DP',
  'caseDetails.caseCreationDatetime.label': 'Creation date',
  'caseDetails.periodExecution.label': 'Period execution',
  'caseDetails.receiptMaterialsDatetime.label': 'Materials receiving date',
  'caseDetails.materialsReturnedDate.label': 'Materials returned at',
  'caseDetails.patientName.label': 'Patient name',
  'caseDetails.patientPhone.label': 'Patient phone',
  'caseDetails.patientAddress.label': 'Patient address',
  'caseDetails.patientEmail.label': 'Patient email',
  'caseDetails.outgoingDiagnosis.label': 'Outgoing diagnosis',
  'caseDetails.price.label': 'Price',
  'caseDetails.clientSpecialist.label': 'Client specialist',
  'caseDetails.holdHistory.label': 'Hold history',
  'caseDetails.holdHistory.start.label': 'Start',
  'caseDetails.holdHistory.stop.label': 'Finish',
  'caseDetails.holdHistory.reason.label': 'reason',
  'caseDetails.ecdcHistory.label': 'Estimated completion datetime correction history',
  'caseDetails.ecdcHistory.date.label': 'Date',
  'caseDetails.ecdcHistory.hours.label': 'Hours',
  'caseDetails.ecdcHistory.reason.label': 'Reason',
  'caseDetails.holdHistory.noHistory.label': 'No history',
  'caseDetails.ecdcHistory.noHistory.label': 'No history',
  'cases.showReport.case.title': 'Case',
  'cases.showReport.sentAt.title': 'Report sent at',
  'cases.showReport.downloadButton.title': 'Download',
  'cases.showReport.downloadButton.titleNoHeader': 'Download without header',

  'createCase.title': 'Case registration',
  'caseCreationOrderForm.fields.patientName.label': 'Name',
  'caseCreationOrderForm.fields.patientGender.label': 'Gender',
  'caseCreationOrderForm.fields.patientGender.options.male': 'M',
  'caseCreationOrderForm.fields.patientGender.options.female': 'F',
  'caseCreationOrderForm.fields.patientBirthday.label': 'Birthday date',
  'caseCreationOrderForm.fields.patientBirthday.placeholder': 'DD.MM.YYYY',
  'caseCreationOrderForm.fields.patientAddress.label': 'Address',
  'caseCreationOrderForm.fields.patientPhone.label': 'Phone',
  'caseCreationOrderForm.fields.patientEmail.label': 'Email',
  'caseCreationOrderForm.fields.patientMedicalInsurance.label':'Insurance',
  'caseCreationOrderForm.fields.patientSnils.label': 'SNILS',
  'caseCreationOrderForm.fields.patientRegistrationPlace.label': 'Registration place', 
  'caseCreationOrderForm.fields.patientPlace.options.COUNTRY': 'Country',
  'caseCreationOrderForm.fields.patientPlace.options.CITY': 'City',
  'caseCreationOrderForm.fields.clinicalData.label': 'Important clinical data',
  'caseCreationOrderForm.fields.examination.label': 'Examination task',
  'caseCreationOrderForm.fields.receiveMaterialMethod.label': 'Material collection method',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.endoscopic': 'endoscopic biopsy',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.needle': 'needle biopsy',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.aspiration': 'aspiration biopsy',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.incisional': 'incisional biopsy',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.excisional': 'excisional biopsy',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.surgical': 'surgical material',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.shed': 'spontaneously shed tissue fragments',
  'caseCreationOrderForm.fields.externalId.label': 'External client Id',
  'caseCreationOrderForm.fields.externalLabel.label': 'External label (will be in report)',
  'caseCreationOrderForm.fields.diagnosis.label':'Diagnosis',
  'caseCreationOrderForm.fields.icd10.label':'ICD-10',
  'caseCreationOrderForm.fields.clientSpecialist.label': 'Client specialist',
  'caseCreationOrderForm.fields.services.serviceSelector.label': 'Services',
  'caseCreationOrderForm.subtitle.services.label': 'Services',
  'services.headers.serviceTitle.label': 'Title',
  'services.headers.codeTitle.label': 'Code',
  'services.headers.clientCodeTitle.label': 'Client code',
  'services.headers.priceTitle.label': 'Price',
  'services.headers.quantityTitle.label': 'Quantity',
  'services.titleOrCodeFilter.label': 'Search by title / code',
  'services.selectedUpper.label': 'Up selected',

  'caseCreationOrderForm.subtitle.files.label': 'Files',

  'caseCreationOrderForm.subtitle.materials.label': 'Diagnostic materials',
  'caseCreationOrderForm.subtitle.additionalMaterials.label': 'Additional materials',
  'materials.creationForm.fields.type.label': 'Type',
  'materials.creationForm.fields.code.label': 'Code',
  'materials.creationForm.fields.code.hint': 'The code must be without extra spaces, strictly as on the label.',
  'materials.creationForm.fields.code.tooltip': 'Do not forget that for each type of material - its own labeling. UNT - for packing (containers), UNS - for glasses, UNB - for blocks. Please stick a label for your material on each material. <b> Code must be entered without spaces </b>. Please stick the UNIM sticker on the glass from the side opposite to the “native” sticker so as not to overlap the incoming material marking.',
  'materials.creationForm.fields.fragments.label': 'Number of fragments',
  'materials.creationForm.fields.fragments.errors.required': 'Enter the number of fragments',
  'materials.creationForm.fields.fragments.errors.number': 'The number of fragments must be an integer',
  'materials.creationForm.fields.fragments.errors.min': 'The number of fragments must be at least 1',
  'materials.creationForm.fields.description.label': 'Description',
  'materials.creationForm.buttons.create.label': 'Create',
  'materials.creationForm.buttons.cancel.label': 'Cancel',
  'materials.creationForm.fields.type.errors.required': 'Selecte material type',
  'materials.creationForm.fields.code.errors.required': 'Value required',
  'materials.creationForm.fields.code.errors.length': 'The length of the code should be no more than 100 characters',
  'materials.creationForm.fields.code.errors.exists': 'Material with this code already exists. Please, enter another code',
  'materials.creationForm.fields.description.errors.required': 'Value required',
  'materials.creationForm.fields.description.errors.length': 'The length of the description should be no more than 200 characters',
  'materials.subtitle.tissues': 'Raw materials in formalin',
  'materials.subtitle.blocks': 'Histological blocks',
  'materials.subtitle.slides': 'Histological preparations',
  'materials.subtitle.documents': 'Paper documents',
  'materials.subtitle.files': 'Electronic media',
  'materials.buttons.addMaterial.title': 'Add material',
  'createCase.buttons.create.label': 'Create',
  'createCase.buttons.toDraft.label': 'Draft',
  'createCase.buttons.toValidation.label': 'To validation',
  'createCase.buttons.clear.label': 'Clear',

  'files.buttons.uploadFile.title': 'Upload',
  'files.sent.title': 'Sent to laboratory',
  'files.errors.unableToUploadFile': 'Unable to upload file, please try again later',

  'caseCreationOrderForm.fields.patientName.errors.required': 'Enter patient name',
  'caseCreationOrderForm.fields.patientName.errors.length': 'The length of the name should be no more than 100 characters',
  'caseCreationOrderForm.fields.patientGender.errors.required': 'Select patient gender',
  'caseCreationOrderForm.fields.patientBirthday.errors.required': 'Select patient birthday',
  'caseCreationOrderForm.fields.patientBirthday.errors.invalid': 'Enter a valid date in DD.MM.YYYY format',
  'caseCreationOrderForm.fields.patientPhone.errors.length': 'The length of the phone number should be no more than 25 characters',
  'caseCreationOrderForm.fields.patientEmail.errors.length': 'The length of the email should be no more than 25 characters',
  'caseCreationOrderForm.fields.patientMedicalInsurance.errors.length': 'The length of the medical insurance should be no more than 16 characters',
  'caseCreationOrderForm.fields.snils.errors.length': 'The length of the snils should be no more than 11 characters',
  'caseCreationOrderForm.fields.snils.errors.valid': 'snils is not valid',
  'caseCreationOrderForm.fields.diagnosis.errors.required': 'Enter diagnosis',
  'caseCreationOrderForm.fields.diagnosis.errors.length': 'The length of the diagnosis should be no more than 200 characters',
  'caseCreationOrderForm.fields.clinicalData.errors.length': 'The length of the clinical data should be no more than 10000 characters',
  'caseCreationOrderForm.fields.externalId.errors.length': 'The internal case id should be no more than 1000 characters',
  'caseCreationOrderForm.fields.externalLabel.errors.length': 'The external label should be no more than 1000 characters',
  'caseCreationOrderForm.fields.material_sampling.label': 'Chose material sampling date',
  'caseCreationOrderForm.messages.unableToCreate': 'Unable to create case',
  'caseCreationOrderForm.messages.backendValidationErrors': 'Some field values is incorrect',
  'caseCreationOrderForm.messages.successCreate': 'Case creation order was successfully created.',

  'caseCreationOrders.filters.statuses.label': 'Select statuses',
  'caseCreationOrders.filters.creationDatetime.label': 'Creation datetime range',
  'caseCreationOrders.filters.creationDatetime.start.label': 'Start Date ',
  'caseCreationOrders.filters.creationDatetime.end.label': 'End Date ',

  'caseCreationOrders.table.columns.header.id': '#',
  'caseCreationOrders.table.columns.header.createdAt': 'Created at',
  'caseCreationOrders.table.columns.header.caseTitle': 'UNIM case title',
  'caseCreationOrders.table.columns.header.patientName': 'Patient',
  'caseCreationOrders.table.columns.header.specialist': 'Specialist',
  'caseCreationOrders.table.columns.header.status': 'Status',
  'caseCreationOrders.table.columns.header.blank': 'Blank',
  'caseCreationOrders.table.blank.button': 'Blank',
  'caseCreationOrders.messages.unableToGenerateBlank': 'Unable to generate the blank',
  'caseCreationOrders.messages.successCancel': 'Order was successfully canceled',
  'caseCreationOrders.messages.successDeclined': 'Order was successfully declined',

  'createCaseCreationOrders.messages.materialCreationSuggest': 'The code of the new material is filled. To complete the addition, select the type of material.',
  'createCaseCreationOrders.messages.materialIsAlreadyExists': 'Material with this code already exists.',
  'createCaseCreationOrders.messages.caseCreationOrderFound': 'The transition to the application for the diagnostics on the material with the code:',

  'updateCaseCreationOrder.title': 'Edit case creation order',
  'updateCaseCreationOrder.status': 'Status',
  'updateCaseCreationOrder.declineReason': 'Decline reason',
  'updateCaseCreationOrder.links.backToCaseCreationOrders': 'To order list',
  'updateCaseCreationOrder.buttons.toDiagnostics.label': 'Send to diagnostic',
  'updateCaseCreationOrder.buttons.update.label': 'Save changes',
  'updateCaseCreationOrder.buttons.toValidation.label': 'Send to validation',
  'updateCaseCreationOrder.buttons.decline.label': 'Decline',
  'updateCaseCreationOrder.buttons.cancel.label': 'Cancel',
  'updateCaseCreationOrder.messages.cancelConfirmation': 'Are you sure to cancel case creation order from ',
  'updateCaseCreationOrder.decline.title': 'Order cancellation',
  'updateCaseCreationOrder.decline.errors.required': 'Enter decline reason',
  'updateCaseCreationOrder.decline.errors.length': 'The length of the decline reason should be no more than 2000 characters ',
  'updateCaseCreationOrder.decline.buttons.ok.label': 'Ok',
  'updateCaseCreationOrder.decline.buttons.cancel.label': 'Cancel'


}
